
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_l809c_im8v7_5"
};
  